import * as v from 'valibot';
import { CaptchaSolution, ChallengeResponse, Features, PublicConfig, RedemptionResponse, WaitlistEntry, } from '../resources/index.js';
import { api } from './_base.js';
export const publicContracts = api({
    'POST /api/waitlist': {
        input: WaitlistEntry,
        output: v.object({
            success: v.literal(true),
        }),
        requiresSession: false,
    },
    'GET /api/config': {
        input: v.object({}),
        output: PublicConfig,
        requiresSession: false,
    },
    'GET /api/features': {
        input: v.object({}),
        output: Features,
        requiresSession: false,
    },
    'POST /api/proof-of-work/challenge': {
        input: v.object({}),
        output: ChallengeResponse,
        requiresSession: false,
    },
    'POST /api/proof-of-work/redeem': {
        input: CaptchaSolution,
        output: RedemptionResponse,
        requiresSession: false,
    },
});
//# sourceMappingURL=public.js.map